module.exports = __webpack_public_path__ + "img/icon-search-blue.91af3bb9.svg";